var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('BlogCategory')]},proxy:true}])},[_c('BlogList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }